define('vspot-angular/resources/charges-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // See user-resource for general documentation
        return $resource('/api/charges/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                createSubscription: {
                    method:'POST',
                    params: {
                        controller: 'create_subscription'
                    }
                },

                createSubscriptionNew: {
                    method:'POST',
                    params: {
                        controller: 'create_subscription_new'
                    }
                },

                createSubscriptionElement: {
                    method:'POST',
                    params: {
                        controller: 'create_subscription_element'
                    }
                },

                paymentAttemptElement: {
                    method: 'POST',
                    params: {
                        controller: 'payment_attempt_element'
                    }
                },
                invoiceFinalizeElement: {
                    method: 'POST',
                    params: {
                        controller: 'invoice_finalize_element'
                    }
                },
                updateSubscription: {
                    method:'POST',
                    params: {
                        controller: 'update_subscription'
                    }
                },
                updateSubscriptionElement: {
                    method:'POST',
                    params: {
                        controller: 'update_subscription_element'
                    }
                },
                accountCreateStandard: {
                    method: 'POST',
                    params: {
                        controller: 'account_create_standard'
                    }
                },
                disconnect: {
                    method: 'POST',
                    params: {
                        controller: 'disconnect'
                    }
                },
                salestax: {
                    method: 'POST',
                    params: {
                        controller: 'salestax'
                    }
                },
                salestaxInvoice: {
                    method: 'POST',
                    params: {
                        controller: 'salestax_invoice'
                    }
                }
            }
        );
    }];
});
